module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"code":"Code","value":"Value"},"et":{"code":"Code","value":"Value"},"ru":{"code":"Code","value":"Value"}}')
  delete Component.options._Ctor
}
